import React from 'react'
import { useTranslation } from 'react-i18next'

import i18n from '@src/config/i18n'

import { getAboutUsLinks } from '../constants/aboutUs'
import MegaMenu from '../menu/MegaMenu'

type Props = {
  open: boolean
}

export default function AboutUsTabMenu({ open }: Props) {
  const { t } = useTranslation('revamp')
  const locale = i18n.language

  const links = getAboutUsLinks(t, locale)

  return (
    <MegaMenu open={open}>
      <section className='flex flex-col items-start w-2/5'>
        <div className='flex flex-col items-start gap-8 text-r-3xl font-bold leading-none text-revamp-red-100'>
          {links.map((link) => (
            <a
              className='underline-thick hover:underline hover:text-white'
              key={`about_us_tab_${link.title}`}
              href={link.link}
            >
              {link.title}
            </a>
          ))}
        </div>
      </section>
    </MegaMenu>
  )
}
